import { styled } from '@mui/material'
import { Box } from '../box'

export const StyledBox = styled(Box)<{ bkgColor: string }>(({ bkgColor }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px',
  backgroundColor: bkgColor,
}))
